<template>
  <v-layout wrap align-center justify-center>
    <v-flex xs12 v-if="enableCollapsing && index === 0" pt-3>
      <div style="border-bottom: 1px solid #ddd; height: 1px; width: 100%;"></div>
    </v-flex>
    <v-flex
      :xs10="enableCollapsing"
      :xs12="!enableCollapsing"
      :py-2="enableCollapsing"
      :pt-3="!enableCollapsing"
      :pb-1="!enableCollapsing"
      @click="openCollapsed"
    >
      <h3>{{ featureGroup && featureGroup.groupName_en === 'House'
      ? capitalize(object.exactType && object.exactType['typeName_' + lang] || object.type['typeName_' + lang])
      : featureGroup && featureGroup['groupName_' + lang] }}</h3>
    </v-flex>
    <v-flex v-if="enableCollapsing" xs2 py-2 @click="openCollapsed" class="feature-collapse-icon">
      <v-icon small>{{ collapsed ? 'fa-chevron-down' : 'fa-chevron-up' }}</v-icon>
    </v-flex>
    <v-flex
      v-if="!collapsed"
      xs12
      :pb-4="enableCollapsing"
      :pt-2="enableCollapsing"
    >
      <!-- object size special bullet -->
      <template v-if="featureGroup && featureGroup.groupName_en === 'House' &&
        (object.squareMeters || object.floors)">
        <v-layout>
          <v-flex xs1 class="text-xs-right" pr-1>
          </v-flex>
          <v-flex xs1 class="text-xs-center">
            <v-icon small style="width: 30px;">
              fa-home
            </v-icon>
          </v-flex>
          <v-flex xs10>
            {{ areAndFloorInfo }}
          </v-flex>
        </v-layout>
      </template>
      <!-- // object size special bullet -->
      <!-- max person special bullet -->
      <template v-if="featureGroup && featureGroup.groupName_en === 'House' && object.maxPeople > 0">
        <v-layout>
          <v-flex xs1 class="text-xs-right" pr-1>
          </v-flex>
          <v-flex xs1 class="text-xs-center">
            <v-icon small style="width: 30px;">
              fa-users
            </v-icon>
          </v-flex>
          <v-flex xs10>
            {{ capitalize($i18n.t('max')) }} {{ object.maxPeople }} {{ $i18n.t('inimest') }}
          </v-flex>
        </v-layout>
      </template>
      <!-- // max person special bullet -->
      <!-- rooms special bullets -->
      <v-layout v-if="featureGroup && featureGroup.groupName_en === 'House'">
        <v-flex xs1 class="text-xs-right" pr-1>
        </v-flex>
        <v-flex xs1 class="text-xs-center">
          <v-icon small style="width: 30px;">
            fa-bed
          </v-icon>
        </v-flex>
        <v-flex xs10>
          {{ object.bedrooms }} {{ object.bedrooms > 1 ? $i18n.t('magamistoaga') : $i18n.t('magamistuba') }}
        </v-flex>
      </v-layout>
      <v-layout v-if="featureGroup && featureGroup.groupName_en === 'House'">
        <v-flex xs1 class="text-xs-right" pr-1>
        </v-flex>
        <v-flex xs1 class="text-xs-center">
          <v-icon small style="width: 30px;">
            fa-bath
          </v-icon>
        </v-flex>
        <v-flex xs10>
          {{ object.bathrooms }} {{ object.bathrooms > 1 ? $i18n.t('vannitoaga') : $i18n.t('vannituba') }}
        </v-flex>
      </v-layout>
      <!-- // rooms special bullets -->
      <v-layout
        v-for="(feature, fIndex) in objectFeatures.filter(f => {
          return featuresList[f.id] && featuresList[f.id].group && featuresList[f.id].group['_id'] === featureGroup['_id']
          })"
        :key="fIndex + '_'"
      >
        <template v-if="featuresList[feature.id] && feature.checked === true">
          <v-flex xs1 class="text-xs-right" pr-1>
            <template v-if="feature.quantity">
              {{ feature.quantity }} x
            </template>
          </v-flex>
          <v-flex xs1 text-xs-center>
            <v-icon small style="width: 30px;">
              {{ featuresList[feature.id].icon }}
            </v-icon>
          </v-flex>
          <v-flex xs10>
            {{ capitalize(featuresList[feature.id]['name_' + lang]) +
            (feature.distance
              ? ': ' + feature.distance
              : '') }}
            {{ feature.extraInfo
              ? '(' +
                (featuresList[feature.id].extraInfoTranslationCode
                ? $i18n.t(featuresList[feature.id].extraInfoTranslationCode) + ' '
                : '') +
              feature.extraInfo + ')' : '' }}
          </v-flex>
        </template>
      </v-layout>
    </v-flex>
    <v-flex xs12 v-if="enableCollapsing">
      <div style="border-bottom: 1px solid #ddd; height: 1px; width: 100%;"></div>
    </v-flex>
  </v-layout>
</template>

<script>
import sharedMethods from './../methods/sharedMethods'
import ContactUsMenu from './../components/_ContactUsMenu'
import ObjectRoomFeatures from './../components/ObjectRoomFeatures'
import MyLoader from './../components/_MyLoader'
import methods from './../methods'
import ObjectPrice from './ObjectPrice'
import ObjectImages from './ObjectImages'
import { createHelpers } from 'vuex-map-fields'
import CalendarNavigation from './../components/CalendarNavigation'
import state from './../state.js'
import moment from 'moment'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'ObjectInfoFeaturesForGroup',

  data () {
    return {
      collapsed: false,
      enableCollapsing: false
    }
  },

  components: {
    ObjectImages,
    ObjectPrice,
    CalendarNavigation,
    MyLoader,
    ContactUsMenu,
    ObjectRoomFeatures
  },

  props: {
    featureGroup: {
      type: Object,
      default: () => {
        return {}
      }
    },

    index: {
      type: Number,
      default: -1
    },

    object: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  created () {
    if (this.mobile && this.featureGroup.id !== '5bc978b1e07c9e232eca5699') {
      this.collapsed = true
      this.enableCollapsing = true
    }
  },

  computed: {
    ...mapFields(Object.keys(state)),

    areAndFloorInfo () {
      let infos = []
      if (this.object.squareMeters) {
        infos.push(this.object.squareMeters + ' m2')
      }

      if (this.object.onFloor) {
        infos.push(this.$i18n.t('floor') + ': ' + this.object.onFloor)
      }
      if (this.object.floors) {
        const title = this.object.floors === 1
          ? this.$i18n.t('floor')
          : this.$i18n.t('floors')
        infos.push(this.object.floors + ' ' + title)
      }

      return infos.join(', ')

      // {{ object.squareMeters ? object.squareMeters + ' m2' : '' }}{{ (
      //   object.onFloor
      //     ? object.squareMeters
      //       ? ', ' + $i18n.t('floor') + ': ' + object.onFloor
      //       : $i18n.t('floor') + ': ' + object.onFloor
      //     : ''
      //   ) }}{{ (
      //   object.floors
      //     ? object.squareMeters
      //       ? ', ' + object.floors + ' ' + object.floors === 1 ? $i18n.t('floor') : $i18n.t('floors')
      //       : object.floors + ' ' + object.floors === 1 ? $i18n.t('floor') : $i18n.t('floors')
      //     : ''
      //   ) }}

    },

    objectFeatures () {
      if (!this.object.features) { return [] }
      return Object.keys(this.object.features).map(id => {
        let feature = this.object.features[id]
        feature['id'] = id
        return feature
      })
    }

  },

  methods: {
    ...sharedMethods,

    openCollapsed () {
      if (this.enableCollapsing) {
        this.collapsed = !this.collapsed
      }
    }
  }
}
</script>

<style>
.feature-collapse-icon {
  text-align:right;
}
.feature-collapse-icon i {
  position: relative;
  top: 2px;
  right: 5px;
}
</style>
